import React from 'react'

import { Type } from 'components/base/Form/Input/types'

import { Props } from './types'

import Input from './index.presentational'

const InputContainer: React.FC<Props> = ({
  createdByCorrectParent = false,
  defaultValue, /* eslint-disable-line @typescript-eslint/no-unused-vars */ // prevent this from being passed in htmlProps
  type = Type.text,
  ...props
}): React.ReactElement => {
  if (!createdByCorrectParent) {
    throw new Error(
      'Do not directly use the Form/Input/Input component. Instead, use Form/Input and pass a `type` prop such as `text`, `number`, `email`, `date`, etc.',
    )
  }

  let componentType = 'input'
  let htmlType = type
  if (type === Type.address) {
    componentType = type
    htmlType = Type.text
  }
  else if (type === Type.date || type === Type.datetime || type === Type.time) {
    componentType = type
    htmlType = type
  }

  return React.createElement(Input, {
    ...props,
    componentType,
    type: htmlType,
  })
}

export * from './types'

export default InputContainer
